import { render, staticRenderFns } from "./AdminCreditCustomerDetail.vue?vue&type=template&id=68d9fa2d&"
import script from "./AdminCreditCustomerDetail.vue?vue&type=script&lang=js&"
export * from "./AdminCreditCustomerDetail.vue?vue&type=script&lang=js&"
import style0 from "./AdminCreditCustomerDetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports